import CheckListConstants from "./CheckListConstants";
import { call } from "../dashboard/service";

export default {
  namespaced: true,
  state: {
    checklist: [],
    alert: {
      status: "",
      message: "",
    },
  },

  mutations: {
    SET_CHECKLIST: (state, payload) => {
      state.checklist = payload;
    },
    SET_ALERT: (state, payload) => {
      state.alert = payload || {
        status: "",
        message: "",
      };
    },
  },

  getters: {
    checklist: (state) => state.checklist,
    alert: (state) => state.alert,
  },

  actions: {
    getChecklist: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", CheckListConstants.checklist(payload))
        .then((res) => {
          commit("SET_CHECKLIST", res.data.data.checklist);
          commit("Dashboard/SET_LOADING", false, { root: true });
          localStorage.setItem(
            process.env.VUE_APP_NAME + "_profile_complete",
            res.data.data["profileComplete"],
          );
        })
        .catch((err) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
  },
};
